module.exports = __webpack_public_path__ + "static/media/follow.4dce774d.svg";